module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07498_logo_200x200.f3b5774e.png";